// SUP-1015: shown when a payment request was sent but its answer never arrived
export const PAYMENT_UNCONFIRMED_MSG = "Your connection dropped before we could confirm your payment. It may still have gone through. Check Transaction History before paying again.";

// SUP-1015: RFC 4122 v4 UUID for the payment idempotency key; getRandomValues fallback (iOS < 15.4); null (pay without a key, as before) if no crypto at all
export const newIdempotencyKey = () => {
  try {
    if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
    const b = crypto.getRandomValues(new Uint8Array(16));
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    const h = [...b].map((x) => x.toString(16).padStart(2, "0")).join("");
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
  } catch (e) {
    return null;
  }
};

// SUP-1015: sends one payment with a fresh per-tap key; an error thrown once the request is out is marked paymentUnconfirmed (it may have gone through)
export const submitWithIdempotencyKey = async (payload, { send, beforeSend }) => {
  const idempotencyKey = newIdempotencyKey();
  const data = JSON.stringify(idempotencyKey ? { ...payload, idempotency_key: idempotencyKey } : payload);
  if (beforeSend) beforeSend(idempotencyKey);
  try {
    return { idempotencyKey, res: await send(data) };
  } catch (error) {
    const err = error instanceof Error ? error : new Error(error?.errors?.[0]?.message || "Payment request failed");
    err.paymentUnconfirmed = true;
    err.idempotencyKey = idempotencyKey;
    err.original = error;
    throw err;
  }
};

// SUP-1015: lost answer -> unconfirmed message, history refresh, reason network_unconfirmed; any other error is tracked as before
export const handlePaymentError = (error, { track, failedEvent, notify, refresh }) => {
  if (error?.paymentUnconfirmed) {
    track(failedEvent, {
      payment_method: "ach",
      reason: "network_unconfirmed",
      error: String(error?.message || error),
      idempotency_key: error.idempotencyKey,
    });
    notify(PAYMENT_UNCONFIRMED_MSG);
    refresh();
    return true;
  }
  track(failedEvent, { payment_method: "ach", reason: String(error?.message || error) });
  return false;
};
